import {Injectable} from "@angular/core";
import {SharedLogic} from "./shared.logic";
import {NestApiProvider} from "../../shared/nestjs/nest-api";

@Injectable()
export class EditcompanyProfileLogic {
  constructor(
    private sharedLogic: SharedLogic,
    private nestApiProvider: NestApiProvider,
  ) {
  }

  getCompany({companyId}): Promise<GetCompanyData> {
    return new Promise<GetCompanyData>(async (resolve, reject) => {
      const isGoPathNewExist = await this.nestApiProvider.isGoPathNewExist();
      try {
        if (isGoPathNewExist) {
          const result = await this.sharedLogic.getCompanyNest({companyId});
          const res = result.data;
          const companyCity = '';
          let arrcompanyFax = [], arrcompanyPhone = [];

          if (res.companyFax) {
            if (typeof res.companyFax === "string") {
              res.companyFax = res.companyFax.split(',');
            }
          } else {
            res.companyFax = '';
          }


          if (res.companyPhone) {
            if (typeof res.companyPhone === "string") {
              res.companyPhone = res.companyPhone.split(',');
            }
          } else {
            res.companyPhone = '';
          }

          res.companyLogo = res.companyLogo || '';

          if (res.companyPhone.length > 0) {
            let x = 1;
            for (const phone of res.companyPhone) {
              const objPhone = {
                id: x,
                name: phone
              };
              arrcompanyPhone.push(objPhone);
              x++;
            }
          } else {
            arrcompanyPhone = [{id: '1', name: ''}];
          }

          if (res.companyFax.length > 0) {
            if (typeof res.companyFax === "string") {
              res.companyFax = res.companyFax.split(',');
            }
            let x = 1;
            for (const fax of res.companyFax) {
              const objFax = {
                id: x,
                name: fax
              };
              arrcompanyFax.push(objFax);
              x++;
            }
          } else {
            arrcompanyFax = [{id: '1', name: ''}];
          }

          try {
            res.companyCity = result["gemcity"].cityName;
          } catch (error) {
            res.companyCity = '';
          }

          const output: GetCompanyData = {...res, companyCity, arrcompanyFax, arrcompanyPhone};
          resolve(output);
        } else {
          const res = await this.sharedLogic.getCompanyLB({companyId});
          const result: GetCompanyData = res[0];
          if (result.companyPhone) {
            if (typeof result.companyPhone === "string") {
              result.companyPhone = result.companyPhone.split(',');
            }
          } else {
            result.companyPhone = '';
          }

          if (result.companyFax) {
            if (typeof result.companyFax === "string") {
              result.companyFax = result.companyFax.split(',');
            }
          } else {
            result.companyFax = '';
          }

          result.companyLogo = result.companyLogo || '';


          if (result.companyPhone.length > 0) {
            let x = 1;
            result.arrcompanyPhone = [];
            for (const phone of result.companyPhone) {
              const objPhone = {
                id: x,
                name: phone
              };
              result.arrcompanyPhone.push(objPhone);
              x++;
            }
          } else {
            result.arrcompanyPhone = [{id: '1', name: ''}];
          }

          if (result.companyFax.length > 0) {
            if (typeof result.companyFax === "string") {
              result.companyFax = result.companyFax.split(',');
            }
            result.arrcompanyFax = [];
            let x = 1;
            for (const fax of result.companyFax) {
              const objFax = {
                id: x,
                name: fax
              };
              result.arrcompanyFax.push(objFax);
              x++;
            }
          } else {
            result.arrcompanyFax = [{id: '1', name: ''}];
          }

          try {
            result.companyCity = result.gemcity.cityName;
          } catch (error) {
            result.companyCity = '';
          }

          resolve(result);
        }
      } catch (e) {
        reject(e);
      }
    })
  }
}

export interface GetCompanyData {
  gemcity?: any;
  companyCity: any;
  arrcompanyFax: any[];
  arrcompanyPhone: any[];
  companyId: number;
  companyCode: string;
  companyName: string;
  nickName: string;
  companyLevel?: number;
  parentId: number;
  status?: number;
  isbase: number;
  companyType?: any;
  companyLogo: string;
  companyAddress: string;
  companyAddress2?: any;
  companyPhone: string | any[];
  companyFax: string | any[];
  companyEmail: string;
  companyCountry: string;
  companyState: string;
  companyZipcode: string;
  taxfilenumber: string;
  taxlocationCode: string;
  taxcountry: string;
  currencyCode: string;
  cityId?: any;
  stateId: number;
  countryId: number;
  visionEn?: any;
  visionId?: any;
  visionMy?: any;
  visionTh?: any;
  missionEn?: any;
  missionId?: any;
  missionMy?: any;
  missionTh?: any;
  createdDate: Date;
  createdBy: string;
  modifiedDate: Date;
  modifiedBy: string;
  taxoffice?: any;
  gmtId: number;
  localName?: any;
  uen?: any;
}



// WEBPACK FOOTER //
// ./src/providers/component-logic/editcompany-profile.logic.ts